// extracted by mini-css-extract-plugin
export default {"list":"styles_list__0KJkE","item":"styles_item__5pcAQ"};